import { createModel } from '@rematch/core';
import { get, post } from 'utils/http';

export default createModel()({
  state: {},
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    async createModelTaskBatch(data = {}) {
      const rst = await post('/api/modelInterface/createModelTaskBatch', data);
      return rst;
    },
    async createModelTask(data = {}) {
      const rst = await post('/api/modelInterface/createModelTask', data);
      return rst;
    },
  },
});
